import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { SeguroStore } from '@interfaces/seguro-store.interface';
import { Store } from '@services/store.service';

@Component({
  selector: 'app-public',
  templateUrl: './public.component.html',
  styleUrls: ['./public.component.css'],
})
export class PublicComponent implements OnInit {
  imgUrl: SafeUrl | null = null;

  constructor(
    private store: Store<SeguroStore>,
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.obtenerImagen();
  }

  obtenerImagen(): void {
    const state = this.store.getState();
    const { convenioResponse } = state;

    if (convenioResponse.tieneBanner) {
      const { banner } = this.route.snapshot.data;
      this.imgUrl = this.sanitizer.bypassSecurityTrustUrl(banner);
    }
  }
}
